<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">{{ $route.name }}</div>
      <div class="right" v-if="PERMISIONS.create">
        <div class="right" style="margin-top: 1.2rem">
          <div @click="addItem" class="Button1 Btn_center">
            <div class="icon">
              <img
                @load="imgLoaded"
                src="../assets/media/for_table/circle_ADD_new_etap.svg"
                alt=""
              />
            </div>
            <span class="Btn_content"> Adaugă </span>
          </div>
        </div>
      </div>
    </div>

    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          apiModuleName="ASSIGNMENT_CONFIG"
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          :tableMinimizeHead="true"
          :tableSpread="true"
          @Btn2="editItem"
          @Btn3="deleteItem"
          @totalRecords="(x) => (totalRecords = x)"
        />
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "../mixins/assignmentConfigPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { ASSIGNMENT_CONFIG } from "../api.js";
import DialogModal from "@/components/DialogModal";
import TableParent from "@/components/TableParent";
import AssignmentConfigEdit from "@/components/AssignmentConfigEdit.vue";

export default {
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },
  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
  },
  data() {
    return {
      centralization: null,
      tableHead: [
        {
          title: "Identificator",
          sort: true,
          queryKey: "assignmentNumber",
          bottomHead: {
            quikFiltre: true,
          },
        },
      ],
      tableModule: ASSIGNMENT_CONFIG.get,
      totalRecords: 0,
      reloadTable: 0,
    };
  },
  methods: {
    reload() {
      this.reloadTable++;
    },

    prepareData(row) {
      const preparation = [row.identifier || ""];

      const prepareBtn = [];

      const x = this.PERMISIONS;

      if (x.edit === true) {
        prepareBtn.push(2);
      }
      if (x.delete === true) {
        prepareBtn.push(3);
      }

      if (prepareBtn.length) {
        preparation.push([prepareBtn]);
      }

      return preparation;
    },

    addItem(item) {
      this.$modal.show(
        DialogModal,
        {
          target: "AddAcqConfig",
          title: "Adaugare configurație",
          inputs: [
            {
              id: "assignmentConfig",
              type: "component",
              component: AssignmentConfigEdit,
              componentProps: { initial: null },
            },
          ],
          closeBtnText: "Anulează",
          acceptFinish(data) {
            const assignmentConfig = data.assignmentConfig;

            for (const key in assignmentConfig) {
              if (!assignmentConfig[key]) {
                this.$toastr.w("Nu au fost completate toate secțiunile.");
                return false;
              }

              if (typeof assignmentConfig[key] == "object") {
                for (const k in assignmentConfig[key]) {
                  if (!assignmentConfig[key][k]) {
                    this.$toastr.w(`Nu au fost completat secțiunea ${k}.`);
                    return false;
                  }
                }
              }
            }
            return true;
          },
          button: {
            type: 2,
            value: "Salvează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Configurarea nu a fost încărcate.");
                this.reload();
                this.setLoad();
              };

              this.setLoad(true);

              ASSIGNMENT_CONFIG.add(data.assignmentConfig)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Configurarea a fost salvată.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "AddAcqConfig",
          adaptive: true,
          width: "750px",
          height: "670px",
        }
      );
    },

    editItem(item) {
      this.$modal.show(
        DialogModal,
        {
          target: "EditAcqConfig",
          title: "",
          inputs: [
            {
              id: "assignmentConfig",
              type: "component",
              component: AssignmentConfigEdit,
              componentProps: { initial: item },
            },
          ],
          acceptFinish(data) {
            const assignmentConfig = data.assignmentConfig;

            for (const key in assignmentConfig) {
              if (!assignmentConfig[key]) {
                this.$toastr.w("Nu au fost completate toate secțiunile.");
                return false;
              }

              if (typeof assignmentConfig[key] == "object") {
                for (const k in assignmentConfig[key]) {
                  if (!assignmentConfig[key][k]) {
                    this.$toastr.w(`Nu au fost completat secțiunea ${k}.`);
                    return false;
                  }
                }
              }
            }

            return true;
          },
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Salvează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Salvarea a eșuat.");
                this.setLoad();
              };

              this.setLoad(true);
              ASSIGNMENT_CONFIG.edit(item.id, {
                ...data.assignmentConfig,
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Configurarea a fost salvată.");
                    this.setLoad();
                    this.reload();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "EditAcqConfig",
          adaptive: true,
          width: "750px",
          height: "670px",
        }
      );
    },

    deleteItem(item) {
      if (!Number.isInteger(item?.id)) {
        return;
      }

      this.$modal.show(
        DialogModal,
        {
          target: "DeleteAcqConfig",
          title: "Șterge achiziție",
          inputs: [],
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(msg || "Configurarea nu a fost ștearsă.");
                this.reload();
                this.setLoad();
              };

              this.setLoad(true);
              ASSIGNMENT_CONFIG.delete(item.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Configurarea a fost ștearsă.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "DeleteAcqConfig",
          adaptive: true,
          width: "650",
          height: "400",
        }
      );
    },
  },

  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    const canViewButtonsColumn = ["edit", "delete"];

    this.updateRoleStatus();
    if (this.checkParamsInObj(this.PERMISIONS, canViewButtonsColumn)) {
      this.tableHead.push({
        spacer: true,
        minimize: 1,
        fixed: {
          right: true,
        },
        bottomHead: {
          quikFiltre: "clear",
        },
      });
    }
  },
};
</script>
<style>
.custom-size {
  max-width: 1200px !important;
  max-height: 100% !important;
}
</style>
